import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PermissionErrorService } from '../../services/permission-error/permission-error.service';

@Injectable()
export class PermissionErrorInterceptor implements HttpInterceptor {
  constructor(private permissionErrorService: PermissionErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          const body = error.error;

          if (body?.data?.code === 'RESOURCE_PERMISSION_DENIED') {
            this.permissionErrorService.emitPermissionDenied({
              permission: body.data.permission,
              reason: body.data.reason,
              message: body.msg || 'No tienes permiso para realizar esta acción',
            });
          }
        }

        return throwError(() => error);
      })
    );
  }
}
